module.exports = __webpack_public_path__ + "img/Aura_freeze.26804586.png";